__webpack_require__.p = "/nauczyciel-ai/";